module.exports = __webpack_public_path__ + "img/kurmalogo.d64443b2.jpg";